<log-ip-field
    [property]="property"
    [ip]="ip"
    [version]="version"
    [port]="port"
    [portProperty]="portProperty"
    [noIpSearchIcon]="noIpSearchIcon"
    [noPortSearchIcon]="noPortSearchIcon"
    (onFilterAdd)="logCinematicStore.closeCinematic()"
></log-ip-field>
